import { Routes, Route, Navigate } from 'react-router-dom';
import { RequireRole } from '../guards/RequireRole';
import AppLayout from '../../components/AppLayout';
import HostDashboard from '../../features/host/pages/HostDashboard';
import HostProfile from '../../features/host/pages/HostProfile';
import CreateListing from '../../features/host/pages/CreateListing';
import EditListing from '../../features/host/pages/EditListing';
import HostTrips from '../../features/host/pages/HostTrips';
import HostBookings from '../../features/host/pages/HostBookings';
import BookingManagement from '../../features/host/pages/BookingManagement';
import Messages from '../../features/host/pages/Messages';

export const HostRoutes = () => {
  return (
    <RequireRole roles="host">
      <AppLayout>
        <Routes>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<HostDashboard />} />
          <Route path="profile" element={<HostProfile />} />
          <Route path="trips" element={<HostTrips />} />
          <Route path="trips/create" element={<CreateListing />} />
          <Route path="trips/:tripId/edit" element={<EditListing />} />
          <Route path="bookings" element={<HostBookings />} />
          <Route path="bookings/:bookingId" element={<BookingManagement />} />
          <Route path="messages" element={<Messages />} />
        </Routes>
      </AppLayout>
    </RequireRole>
  );
};
